<template>
  <div class="HTML_FACERECORD">
    <div class="teamHeader">
      <!-- 队伍Logo与名称 -->
      <span
        class="teamItem"
        v-for="(teamItem, teamItemIndex) in teamBaseInfor"
        :key="teamItemIndex"
      >
        <span class="teamLogo">
          <img :src="teamItem.teamLogo" />
        </span>
        <span class="teamName" v-text="teamItem.teamName"></span>
      </span>

      <!-- 胜负/胜平负统计条 -->
      <span class="winLossInfor">
        <span class="winLossInfor_bar">
          <!-- 足球模式：三段式布局 (主胜 | 平局 | 客胜) -->
          <template v-if="isFootball">
            <!-- 左侧：主胜 -->
            <span
              class="footballBar homeWinBar"
              :style="{ width: winBarObj.homeWinPer + '%' }"
            ></span>
            <!-- 中间：平局 (固定占比，居中显示) -->
            <span
              class="footballBar drawBar"
              :style="{ width: winBarObj.drawPer + '%' }"
            ></span>
            <!-- 右侧：客胜 -->
            <span
              class="footballBar awayWinBar"
              :style="{ width: winBarObj.awayWinPer + '%' }"
            ></span>
          </template>
          <!-- 篮球模式：原有的双色条 -->
          <template v-else>
            <span
              class="leftBar"
              :style="{ width: winBarObj.homeBarPer ? winBarObj.homeBarPer + '%' : '0' }"
            ></span>
            <span
              class="rightBar"
              :style="{ width: winBarObj.awayBarPer ? winBarObj.awayBarPer + '%' : '0' }"
            ></span>
          </template>
        </span>

        <!-- 统计数字 -->
        <span class="winLossInfor_num">
          <span class="leftNum">
            <template v-if="isFootball">
              胜{{ winBarObj.homeWin }} 平{{ winBarObj.draw }} 负{{ winBarObj.homeLose }}
            </template>
            <template v-else>
              {{ winBarObj.homeWin }}胜
            </template>
          </span>
          <span class="rightNum">
            <template v-if="isFootball">
              胜{{ winBarObj.awayWin }} 平{{ winBarObj.draw }} 负{{ winBarObj.awayLose }}
            </template>
            <template v-else>
              {{ winBarObj.awayWin }}胜
            </template>
          </span>
        </span>
      </span>
    </div>

    <!-- 比赛记录列表 (保持原有逻辑) -->
    <div
      class="recordList"
      :class="{ heightScroll: recordList.length > 5 }"
    >
      <span
        class="recordItemRow"
        v-for="(item, itemIndex) in recordList"
        :key="itemIndex"
      >
        <span class="recordItemRow_left" v-text="item.matchDate"></span>
        <span class="recordItemRow_mid">
          <span class="recordItemRow_mid_clo1" v-text="item.homeName"></span>
          <span class="recordItemRow_mid_clo2">
            <span
              class="recordItemRow_mid_clo2_clo1"
              :class="getScoreClass(item.homeScore, item.awayScore)"
            >
              <NumberScrolling
                :tarVal="item.homeScore"
                :unit="''"
              ></NumberScrolling>
            </span>
            <span class="recordItemRow_mid_clo2_clo2" v-text="':'"></span>
            <span
              class="recordItemRow_mid_clo2_clo3"
              :class="getScoreClass(item.awayScore, item.homeScore)"
            >
              <NumberScrolling
                :tarVal="item.awayScore"
                :unit="''"
              ></NumberScrolling>
            </span>
          </span>
          <span class="recordItemRow_mid_clo3" v-text="item.awayName"></span>
        </span>
        <!-- 核心改动：动态绑定胜平负的class，并优先展示competitionName -->
        <span class="recordItemRow_right" v-text="item.competitionName ?? item.phaseName"></span>
      </span>
    </div>
  </div>
</template>

<script>
import NumberScrolling from '@components/compreSportsMeet/html/components/NumberScrolling'

export default {
  name: 'HTML_FACERECORD',
  components: {
    NumberScrolling,
  },
  props: {
    datas: {
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
          awayWin: null,
          homeWin: null,
          draw: 0
        },
        statisticsModels: [],
        pictures: [
          'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
          'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg',
        ],
        videos: [],
      }),
    },
  },
  computed: {
    // 根据是否存在 draw 字段来判断是否为足球模式
    isFootball() {
      const stats = this.datas?.data || {};
      return stats.hasOwnProperty('draw') && stats.draw !== null && stats.draw !== undefined;
    },

    recordList() {
      return this.datas?.data?.dataList || [];
    },

    teamBaseInfor() {
      return this.datas?.objectInfo || [
        { teamId: null, teamLogo: '', teamName: '' },
        { teamId: null, teamLogo: '', teamName: '' }
      ];
    },

    winBarObj() {
      const data = this.datas?.data || {};
      const homeWin = data.homeWin || 0;
      const awayWin = data.awayWin || 0;
      const draw = data.draw || 0;
      const total = homeWin + awayWin + draw;

      if (total === 0) {
        return { homeWin, awayWin, draw, homeLose: 0, awayLose: 0, homeBarPer: 50, awayBarPer: 50, homeWinPer: 0, drawPer: 100, awayWinPer: 0 };
      }

      if (this.isFootball) {
        // 足球模式计算
        // 平局占比：基于总场次
        const drawPer = parseFloat((draw / total * 100).toFixed(2));

        // 主胜和客胜占比：基于“分出胜负的场次”来计算相对宽度
        const winOrLoseTotal = homeWin + awayWin;
        let homeWinPer = 0;
        let awayWinPer = 0;

        if (winOrLoseTotal > 0) {
          homeWinPer = parseFloat((homeWin / winOrLoseTotal * (100 - drawPer)).toFixed(2));
          awayWinPer = parseFloat((awayWin / winOrLoseTotal * (100 - drawPer)).toFixed(2));
        }

        return {
          homeWin, awayWin, draw,
          homeLose: awayWin ,
          awayLose: homeWin ,
          homeWinPer, drawPer, awayWinPer
        };
      } else {
        // 篮球模式计算
        const homeBar = Math.ceil((homeWin / (homeWin + awayWin || 1)) * 1000);
        const awayBar = 1000 - homeBar;
        return {
          homeWin, awayWin, draw: 0,
          homeLose: awayWin,
          awayLose: homeWin,
          homeBarPer: homeBar / 10,
          awayBarPer: awayBar / 10
        };
      }
    },
  },
  methods: {
    getScoreClass(score1, score2) {
      if (!this.isFootball) {
        return score1 >= score2 ? 'fontBold' : '';
      } else {
        return score1 >= score2 ? 'fontBold' : '';
      }
    }
  }
}
</script>

<style lang="scss">
.HTML_FACERECORD {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: calc(100% - 3.6vw);
  .teamHeader {
    position: relative;
    width: 100%;
    height: 4.2vw;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: flex-start;
    color: var(--mixtmt_greyColor2);
    margin-top: 1.1vw;
    .teamItem {
      width: 50%;
      display: flex;
      display: -webkit-flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      .teamLogo {
        display: block;
        width: 2.083vw;
        height: 2.083vw;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .teamName {
        width: 100%;
        font-size: 0.974vw;
        line-height: 1.66vw;
      }
      &:nth-child(2) {
        align-items: flex-end;
        .teamName {
          text-align: right;
        }
      }
    }
    .winLossInfor {
      position: absolute;
      left: 8.33vw;
      top: 0;
      z-index: 2;
      width: calc(100% - 8.33vw - 8.33vw);
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      .winLossInfor_bar {
        position: relative;
        width: 100%;
        height: 0.694vw;
        background-color: #eee;
        display: flex; /* 关键：使用 Flex 布局让三段自然排列 */
        align-items: center;

        /* 篮球原有样式 */
        .leftBar, .rightBar {
          display: block;
          height: 100%;
          z-index: 2;
          width: 0;
          transition: width 0.3s linear;
        }
        .leftBar { background-color: var(--mixtmt_svgColor0); }
        .rightBar { background-color: var(--mixtmt_svgColor1); }

        /* 足球特有样式 */
        .footballBar {
          display: block;
          height: 100%;
          transition: width 0.3s linear;
          &.homeWinBar {
            background-color: var(--mixtmt_svgColor0);
          }
          &.drawBar {
            background-color: #999; /* 平局灰色 */
            /* 平局在中间，左右两侧自然被主胜和客胜挤压 */
          }
          &.awayWinBar {
            background-color: var(--mixtmt_svgColor1);
          }
        }
      }
      .winLossInfor_num {
        width: 100%;
        height: 1.68vw;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.2vw;
        .leftNum, .rightNum {
          width: 50%;
          font-size: 0.974vw;
          line-height: 1.68vw;
        }
        .rightNum { text-align: right; }
      }
    }
  }
  .recordList {
    width: 100%;
    &.heightScroll {
      height: 13.5vw;
      overflow: auto;
      .recordItemRow {
        margin-top: 0.694vw;
      }
    }
    .recordItemRow {
      display: block;
      margin-top: 0.533vw;
      padding: 0 0.694vw;
      width: 100%;
      height: 2.22vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      background-color: var(--mixtmt_greyColor8);
      color: var(--mixtmt_greyColor4);
      .recordItemRow_left {
        width: 6.25vw;
      }
      .recordItemRow_right {
        width: 4.16vw;
      }
      .recordItemRow_mid {
        width: calc(100% - 6.25vw - 4.16vw);
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        .recordItemRow_mid_clo1,
        .recordItemRow_mid_clo3 {
          width: calc(50% - 4vw);
          font-size: 0.974vw;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: var(--mixtmt_greyColor2);
        }
        .recordItemRow_mid_clo1 { text-align: right; }
        .recordItemRow_mid_clo2 {
          width: 8vw;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          .recordItemRow_mid_clo2_clo1 { text-align: right; }
          .recordItemRow_mid_clo2_clo2 { width: 0.694vw; text-align: center; }
          .recordItemRow_mid_clo2_clo3 { text-align: left; }
          .recordItemRow_mid_clo2_clo1,
          .recordItemRow_mid_clo2_clo3 {
            width: calc(50% - 0.347vw);
            &.fontBold {
              font-weight: bold;
              color: var(--mixtmt_greyColor2);
            }
          }
        }
        .recordItemRow_mid_clo3 { text-align: left; }
      }
    }
  }
}
</style>